import React from 'react';
import { useParams } from 'react-router-dom';


function ProductPage() {



  return (
  <div></div>
  );
}

export default ProductPage;
